export default __webpack_public_path__ + "static/media/GLICEMIA_ICONA1.63d1b0d8.svg";